import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_3b508115";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_3b508115" };
/** script content **/
require("./picker.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex3b508115%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fpicker%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_3b508115"],
    ctorType: "component",
    outputPath: "components/index3b508115/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'mpx-picker-view': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-picker-view?isComponent"), { __mpxBuiltIn: true }), 'mpx-picker-view-column': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-picker-view-column?isComponent"), { __mpxBuiltIn: true }), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
